export default "__VITE_ASSET__DLelPmGg__"